import { TranslocoService } from '@ngneat/transloco';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem, SelectItemGroup } from 'primeng/api';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { SALUTATIONS, YESNO } from 'projects/core/src/lib/constants';
import { EmployeeModel } from 'projects/core/src/lib/models/employee.model';
import { EmployeeSearchComponent } from 'projects/admin/src/app/shared/employee-search/employee-search.component';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';

@Component({
  selector: 'app-orderform-candidate',
  templateUrl: './orderform-candidate.component.html',
  styleUrls: ['./orderform-candidate.component.scss']
})
export class PlannerOrderformCandidateComponent implements OnInit, OnChanges {

  @Input() form: UntypedFormGroup;
  @Input() options: { [key: string]: Array<SelectItem | SelectItemGroup> };
  @Input() texts: { [key: string]: string };
  @Input() disabled = true;

  @ViewChild('employeesearch') employeesearch: EmployeeSearchComponent;

  private subForm: UntypedFormGroup = this.fb.group({
    gender: new UntypedFormControl(''),
    firstname: new UntypedFormControl(''),
    lastname: new UntypedFormControl(''),
    email: new UntypedFormControl('', [CustomValidators.email()]),
    phone: new UntypedFormControl(''),
    mobile: new UntypedFormControl(''),
    corporation: new UntypedFormControl(''),
    language: new UntypedFormControl(''),
    function: new UntypedFormControl(''),
    board_division: new UntypedFormControl(''),
  });
  public optionsSalutations: Array<SelectItem> = [];
  public optionsCorporations: Array<SelectItem> = [];
  public boardDivisionVisible = false;

  constructor(
    private fb: UntypedFormBuilder,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.optionsSalutations = FormHelper.getSelectList(SALUTATIONS, null, this.transloco);
    this.optionsCorporations = FormHelper.getSelectList(YESNO, null, this.transloco);
    this.form.addControl('candidate', this.subForm);
    this.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && changes.disabled.currentValue !== changes.disabled.previousValue) {
      if (changes.disabled.currentValue === true) {
        this.disable();
      } else {
        this.enable();
      }
    }
  }

  public setSettings(templateSettings: any, crossSettings: any): void {
    this.boardDivisionVisible = templateSettings.hiringdays === true;
  }

  public getPayload(): any {
    return {
      gender: this.subForm.get('gender').value,
      firstname: this.subForm.get('firstname').value,
      lastname: this.subForm.get('lastname').value,
      email: this.subForm.get('email').value,
      phone: this.subForm.get('phone').value,
      mobile: this.subForm.get('mobile').value,
      corporation: this.subForm.get('corporation').value,
      language: this.subForm.get('language').value,
      function: this.subForm.get('function').value,
      board_division: this.subForm.get('board_division').value,
    };
  }

  public disable(): void {
    this.subForm.get('gender').disable();
    this.subForm.get('firstname').disable();
    this.subForm.get('lastname').disable();
    this.subForm.get('email').disable();
    this.subForm.get('phone').disable();
    this.subForm.get('mobile').disable();
    this.subForm.get('corporation').disable();
    this.subForm.get('language').disable();
    this.subForm.get('function').disable();
    this.subForm.get('board_division').disable();
  }

  public enable(): void {
    this.subForm.get('gender').enable();
    this.subForm.get('firstname').enable();
    this.subForm.get('lastname').enable();
    this.subForm.get('email').enable();
    this.subForm.get('phone').enable();
    this.subForm.get('mobile').enable();
    this.subForm.get('corporation').enable();
    this.subForm.get('language').enable();
    this.subForm.get('function').enable();
    this.subForm.get('board_division').enable();
  }

  public onOpenEmployeeSearch(): void {
    this.employeesearch.open();
  }

  public onSelectEmployee(employee: EmployeeModel): void {
    this.subForm.patchValue({
      gender: this.optionsSalutations.find(gender => gender.value[0] === employee.gender)?.value,
      firstname: employee.firstname,
      lastname: employee.lastname,
      email: employee.email,
      phone: employee.phone,
      mobile: employee.mobile,
    });
  }

}
